import styled, { css } from "styled-components";
import { StyledProps } from "./types";
import { styleTransformHelper as t } from "../../helpers";

export const StyleWrapper = styled.div<StyledProps>(
  ({
    theme: {
      color: {
        errorText,
        hue279Text,
        infoText,
        neutralsTextPrimary,
        neutralsTextPrimaryDisabled,
        neutralsShapeSecondary,
        neutralsShapeTertiary,
        neutralsTextSecondary,
        successText,
        primaryText,
        primaryLight1,
        warningText,
        hue191ShapeHover,
      },
    },
    mode,
    cardColor,
    color,
  }) => {
    const handleCurrentType = () => {
      switch (cardColor) {
        case "white":
          return primaryLight1;
        case "error":
          return errorText;

        case "hueText":
          return hue279Text;

        case "info":
          return infoText;

        case "neutrals":
          return neutralsTextPrimaryDisabled;

        case "success":
          return successText;

        case "ShapeSecondary":
          return neutralsShapeSecondary;

        case "ShapeTertiary":
          return neutralsShapeTertiary;

        case "PrimaryText":
          return primaryText;

        case "TextSecondary":
          return neutralsTextSecondary;

        case "warning":
          return warningText;

        case "hue191":
          return hue191ShapeHover;

        default:
          return neutralsTextPrimary;
      }
    };

    return t(css`
      display: flex;
      align-items: center;
      * {
        display: flex;
        font-style: normal;
        color: ${color ?? handleCurrentType()};
      }

      .Display1,
      .Display2,
      .Display3,
      .BodySemiBold,
      .CaptionSemiBold,
      .AnnotationSemiBold {
        font-weight: 600;
      }
      h1,
      h2,
      h3 {
        font-weight: 500;
      }

      .BodyRegular,
      .CaptionRegular,
      .AnnotationRegular {
        font-weight: 400;
      }
      .BodyRegular,
      .BodySemiBold {
        font-size: 14px;
        line-height: ${mode === "editorial"
          ? "21px"
          : mode === "element"
          ? "14px"
          : "18px"};
      }
      .CaptionRegular,
      .CaptionSemiBold {
        font-size: 12px;
        line-height: ${mode === "editorial"
          ? "18px"
          : mode === "element"
          ? "12px"
          : "15px"};
      }
      .AnnotationRegular,
      .AnnotationSemiBold {
        font-size: 11px;
        line-height: ${mode === "editorial"
          ? "14px"
          : mode === "element"
          ? "13px"
          : "13px"};
      }

      .Display1 {
        font-size: 36px;
        line-height: ${mode === "editorial"
          ? "49px"
          : mode === "element"
          ? "36px"
          : "45px"};
      }
      .Display2 {
        font-size: 30px;
        line-height: ${mode === "editorial"
          ? "41px"
          : mode === "element"
          ? "30px"
          : "38px"};
      }
      .Display3 {
        font-size: 24px;
        line-height: ${mode === "editorial"
          ? "32px"
          : mode === "element"
          ? "24px"
          : "30px"};
      }
      h1 {
        font-size: 21px;
        line-height: ${mode === "editorial"
          ? "32px"
          : mode === "element"
          ? "21px"
          : "26px"};
      }
      h2 {
        font-size: 18px;
        line-height: ${mode === "editorial"
          ? "27px"
          : mode === "element"
          ? "18px"
          : "23px"};
      }
      h3 {
        font-size: 16px;
        line-height: ${mode === "editorial"
          ? "24px"
          : mode === "element"
          ? "16px"
          : "20px"};
      }
    `);
  }
);

export default StyleWrapper;
